"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFlexbox = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("@icr-ui/utils");
exports.StyledFlexbox = styled_components_1.default.div `
  ${({ fullHeight, fullScreen, fullWidth, width, height, customStyles, alignItems, justifyContent, alignSelf, justifySelf, flexDirection, gap, noWrap, }) => {
    return (0, styled_components_1.css) `
      ${(0, utils_1.flexPosition)(alignItems, justifyContent, flexDirection, alignSelf, justifySelf)};
      height: ${(0, utils_1.getHeight)({ fullHeight, fullScreen, height })};
      width: ${(0, utils_1.getWidth)({ fullWidth, fullScreen, width })};
      gap: ${gap !== null && gap !== void 0 ? gap : '0'};
      flex-wrap: ${noWrap ? 'nowrap' : 'wrap'};

      ${customStyles || {}}
    `;
}}
`;
//# sourceMappingURL=styles.js.map